import { getMondayOf, getMondayOfThisWeek } from "./weekDates";

/**
 * Pure helper — seeds the initial `modalWeekStartDate` for the headless
 * temporary-grid pattern used by CrewDetailModal (#132 fix).
 *
 * Context: CrewDetailModal owns its own week state — it acts as a temporary,
 * modal-local "grid" with its own date range that exists for the lifetime of
 * the modal and is discarded on close. The seed comes from the Optimizer
 * grid that opened the modal (when present); otherwise from AppContext's
 * legacy week (Scheduler tab path); otherwise from this week's Monday.
 *
 * The seed value is the Monday of the chosen week so the helper output is
 * always a valid input for `buildWeekDatesArray` / `getPrevWeekMonday` /
 * `getNextWeekMonday`.
 *
 * Selection rule (first viable wins):
 *   1. propWeekDatesArray[0] if prop is a 7-element array with a parseable
 *      first element
 *   2. contextWeekDatesArray[0] if context is a 7-element array with a
 *      parseable first element
 *   3. getMondayOfThisWeek() (today's Monday)
 *
 * @param {Array<string>|null|undefined} propWeekDatesArray
 *   The grid's per-grid week-dates array (set by `onCrewDetailClick` payload).
 * @param {Array<string>|null|undefined} contextWeekDatesArray
 *   AppContext.weekDatesArray (legacy Scheduler-tab path).
 * @returns {Date}  Monday Date object at local 00:00 (snapped by getMondayOf).
 */
export function seedModalWeekStartDate(propWeekDatesArray, contextWeekDatesArray) {
  for (const candidate of [propWeekDatesArray, contextWeekDatesArray]) {
    if (
      Array.isArray(candidate) &&
      candidate.length === 7 &&
      typeof candidate[0] === "string" &&
      candidate[0].length > 0
    ) {
      const parsed = new Date(candidate[0]);
      if (!isNaN(parsed.getTime())) {
        return getMondayOf(parsed);
      }
    }
  }
  return getMondayOfThisWeek();
}
